import { render, staticRenderFns } from "./ForumSubcategory.vue?vue&type=template&id=2bbd0844&"
import script from "./ForumSubcategory.vue?vue&type=script&lang=js&"
export * from "./ForumSubcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports